import { OnboardingResponseStatus } from 'clickNgo/configs/service/onboarding'
import { IContact } from 'clickNgo/entities/contact'
import { updateContact } from 'clickNgo/entities/contact/api'
import { getJSendErrorMessages } from 'clickNgo/helpers/api'

interface IPerformRelink {
  isRelinkingCommentModified?: boolean
  contact: IContact
}

export const performRelink = async ({ isRelinkingCommentModified, contact }: IPerformRelink) => {
  const modifiedValues = ['NewPartnerID']

  if (isRelinkingCommentModified) {
    modifiedValues.push('RelinkingComment')
  }
  const contactForRelink: IContact = {
    ...contact,
    modifiedValues,
  }

  const response = await updateContact(contactForRelink, { forceRoles: true })

  if (response?.status !== OnboardingResponseStatus.Success) {
    return {
      success: false,
      contact: contactForRelink,
      errors:
        response?.status === OnboardingResponseStatus.Fail
          ? getJSendErrorMessages(response)
          : [response?.message || 'Unknown error'],
    }
  }

  return {
    success: true,
    contact: contactForRelink,
    response,
    errors: [],
    responseData: response.data,
  }
}
